import axios from 'axios';

export const state = {
  orderItems: [],
  orderItemsPagination: {},
  loading: false,
};

export const mutations = {
  setOrderItems(context, orderItems) {
    context.orderItems = orderItems;
    context.loading = false;
  },

  setOrderItemsPagination(context, pagination) {
    context.orderItemsPagination = pagination;
    context.loading = false;
  },

  setLoading(context, value) {
    context.loading = value;
  },
};

export const actions = {
  async getOrderItems({ commit, rootState }, query) {
    try {
      const { jwtToken } = rootState.userStore.user.signInUserSession.idToken;
      const options = {
        headers: {
          Authorization: jwtToken,
        },
      };

      commit('setLoading', true);

      const orderItems = await axios.get(`${window.BASE_API.BAADER}/order-items?${query}`, options)
        .then(response => response.data);

      commit('setOrderItems', orderItems.data);
      commit('setOrderItemsPagination', orderItems.pagination);
      commit('setLoading', false);
    } catch (err) {
      commit('setLoading', false);
    }
  },
};

const orderItemsStore = {
  state,
  mutations,
  actions,
};

export default orderItemsStore;



// WEBPACK FOOTER //
// ./src/store/baader/orderItemsStore.js